/**
 * Gracefully handle deprecated props, with warnings as appropriate. Expects to be either bound to 'this', or provided
 * with a props object as its third argument. NOTE: neither of these props can be set in defaultProps for this to
 * work. Instead, defaults on these props should be managed with component code and specified with @default in the
 * prop's jsdoc comment block.
 */
var getDeprecatedPropValue = function getDeprecatedPropValue(deprecatedPropName, newPropName, props) {
  var deprecatedPropIsDefined = Object.prototype.hasOwnProperty.call(props, deprecatedPropName);
  var newPropIsDefined = Object.prototype.hasOwnProperty.call(props, newPropName);
  var deprecatedPropValue = props[deprecatedPropName];
  var newPropValue = props[newPropName]; // if they're both defined, the non-deprecated prop wins

  if (deprecatedPropIsDefined && newPropIsDefined) {
    /* eslint-disable no-console */
    console.warn("Warning: a deprecated prop (".concat(deprecatedPropName, ") and its replacement (").concat(newPropName, ") have been used at the same time. The value of ").concat(newPropName, " will be used in this case, but you should probably fix this."));
    /* eslint-enable no-console */

    return newPropValue;
  } // Okay, they're not both defined, so is it just the deprecated one that's defined? Return that if so.


  if (deprecatedPropIsDefined) {
    return deprecatedPropValue;
  } // If the deprecated one isn't defined, we can do the good thing and return the right one.


  return newPropValue;
};
/**
 * Infers the name of the component being passed as argumnet.
 * On failure, it just returns 'Component'
 * Used for debugging purposes, to make it easier (for example) to identify which HOC is wrapping a component.
 * Also see https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
 * @param Component
 * @returns {string}
 */


var getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
};

export { getDeprecatedPropValue, getDisplayName };
